export default __webpack_public_path__ + "static/media/Lily_Reynaga_Fibromialgia_en_positivo.f4028f76.jpg";